<template>
	<div>
		<canvas ref="chart" :style="{ 'height': height + 'px' }"></canvas>
	</div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

export default ({
	props: [
		'data',
		'height',
	],
	data() {
		return {
			chart: null,
			ctx: null
		};
	},
	watch: {
		data: {
			handler(newData) {
				this.$nextTick(() => {
					this.chart.data = newData
					this.chart.update()
				})
			},
			immediate: false
		}
	},
	mounted() {
		this.ctx = this.$refs.chart.getContext("2d");
		this.chart = new Chart(this.ctx, {
			type: "bar",
			data: {
				labels: ['--', '--', '--', '--', '--', '--',],
				datasets: [{
					label: '收款',
					backgroundColor: '#fff',
					borderWidth: 0,
					borderSkipped: false,
					borderRadius: 6,
					data: [0, 0, 0, 0, 0, 0],
					maxBarThickness: 20,
				}],
			},
			options: {
				layout: {
					padding: {
						top: 30,
						right: 15,
						left: 10,
						bottom: 5,
					},
				},
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: false,
					},
					datalabels: {
						color: '#FFF',
						anchor: 'end', // 标签位置
						align: 'top',  // 对齐方式
						formatter: (value) => value // 空值不显示
					},
				},
				tooltips: {
					enabled: true,
					mode: "index",
					intersect: false,
				},
				scales: {
					y: {
						grid: {
							display: true,
							color: "rgba(255, 255, 255, .2)",
							zeroLineColor: "#ffffff",
							borderDash: [6],
							borderDashOffset: [6],
						},
						ticks: {
							suggestedMin: 0,
							suggestedMax: 1000,
							display: true,
							color: "#fff",
							font: {
								size: 14,
								lineHeight: 1.5,
								weight: '600',
								family: "Open Sans",
							},
						},
					},
					x: {
						grid: {
							display: false,
						},
						ticks: {
							display: true,
							color: "#fff",
							font: {
								size: 14,
								lineHeight: 1.5,
								weight: '600',
								family: "Open Sans",
							},
						},
					},
				},
			}
		});
	},
	// Right before the component is destroyed,
	// also destroy the chart.
	beforeDestroy: function () {
		this.chart.destroy();
	},
})

</script>

<style lang="scss" scoped>
canvas {
	background-image: linear-gradient(to right, #00369E, #005CFD, #A18DFF);
}
</style>